module.exports = __webpack_public_path__ + "img/零代码大语言模型.bbfa5f1e.png";